/**
 * Шаблоны
 */

;
window.TK = (() => {
        "use strict";

        const ModalKit = {
                /**
                 * Требования к файлам.
                 * @returns {String}
                 */
                filesAccept() {
                        const goskeyMaxSizeMessage = PARAMS.goskey_package_max_size && PARAMS.goskey_package_max_size > 0 ? " (для <a href='/goskey' tagret='_blank'>Госключа</a>: " + PARAMS.goskey_package_max_size + " Мб)" : "";

                        return `
				<div class="modal-content-wrapper">
					<div class="dialog-title">Общие требования к загружаемым файлам</div>
					<ul class="modal-pure__infopart">
					    <li>- Допустимые типы файлов: png, jpg, pdf, doc, docx, zip, txt, xls, xlsx (для <a href="/goskey" tagret="_blank">Госключа</a> типы файлов: ${PARAMS.filtered_goskey_allowed_ext})</li>
					    <li>- В некоторых случаях список допустимых типов может быть сокращен.</li>
					    <li>- Максимальный размер: 25 Мб. ${goskeyMaxSizeMessage}</li>
					    <li>- Количество загружаемых файлов ограничено.</li>
					</ul>
					<center>
						<button class="blue-button" type="button">Ознакомлен</button>
					</center>
				</div>
			`;
                },
                lotPhotoRequirements() {
                        return `
				<div class="modal-content-wrapper">
					<div class="dialog-title">Требования к загружаемым изображениям лотов</div>
					<div class="modal-pure__infopart"  style="text-align:left;font-size:16px;padding-left:30px;">
						<div>
							Изображения должны быть хорошего качества, в высоком разрешении, минимальный размер изображений по любой из сторон должен быть не менее 500 пикселей. Рекомендуемый размер 1920x1080 и более.
						</div>
						<div>
							Изображения  должны соответствовать названию и описанию объявления, а также передавать суть вашего предложения.
						</div>
						<div style="margin-right:auto">
							Размер каждого файла не должен превышать 25 Мб.
						</div>
						<div style="margin-right:auto">
							Формат файла должен быть .jpg, .jpeg
						</div>
						<div style="margin-right:auto">
							Разрешено размещать только те изображения, на использование которых у Вас есть законное основание.
						</div>
						<div style="margin-right:auto">
							Не используйте одинаковые изображения.
						</div>
						<div style="margin-right:auto">
							Объект(ы) лота должен быть главным элементом фотографии.
						</div>
						<div style="margin-right:auto">
							Если объект предложения изображен на фоне логотипа, то такой логотип не должен занимать более 5 % фотографии.
						</div>
						<div style="margin-right:auto">
							Если на фотографии изображен человек, лицо необходимо его сделать не идентифицируемым.
						</div>
						<div style="margin-right:auto">
							После подгрузки изображений их нужно правильно сориентировать (повернуть влево или вправо)
						</div>
						<div style="margin-right:auto">
							Также, после подгрузки изображений, необходимо выбрать главное изображение, переместив его слева от первой картинки с помощью курсора.
						</div>
						<div style="margin-right:auto">
							Для удобства рекомендуется подгружать группы изображений, выделив их в открывшемся окне, после нажатия кнопки “Загрузить картинки” (не более 30 шт)
						</div>
						<ul style="list-style: disc;padding:0;margin-right:auto;">
							<li style="font-weight: 700;list-style: none;text-decoration: underline;text-underline-offset: 5px;">Запрещается использовать на подгружаемых изображениях:</li>
							<li> • элементы, привлекающие внимание, например: цветные рамки, слова «срочно»,  «внимание» и т.п., за исключением элементов компьютерной графики, уточняющих местоположение объекта и т.п. </li>
							<li> • элементы компьютерной графики, вводящие в заблуждение, искажающие реальные характеристики имущества, не несущие смысловой нагрузки</li>
							<li> • логотипы, водяные знаки (вотермарки), или иные элементы других Интернет-ресурсов или брендов, названия организаций, имена и т.п.</li>
						</ul>
						<div style="margin-right:auto">
							Мы вправе автоматически наносить на загружаемые вами изображения логотипы/водяные знаки МЭТС, чтобы предотвращать несанкционированное копирование фотографий.
						</div>
						<div style="margin-right:auto">
							Мы вправе не размещать изображения по своему усмотрению, в том числе если они не соответствуют политике площадки.
						</div>
					</div>
				</div>
			`;
                },
                depositTypes(lotId = null, summa = null) {
                        return `
				<div class="modal-content-wrapper select-card-types">

					<div class="dialog-title">
						Пополнение лицевого счета
					</div>
					<div class="modal-pure__infopart">

						<div class="select-card-list">

							<!-- Экспресс-пополнение -->
							<div class="select-card-item select-card-item--express">

								<div class="select-card-top">
									<div class="sbtn express"></div>

									<div class="select-card-badge select-card-badge--recommended">
										<span class="select-card-badge-icon">✓</span>
										РЕКОМЕНДУЕМ
									</div>
								</div>

								<div class="select-card-content">
									<div class="title">
										Экспресс-пополнение
									</div>

									<div class="description">
										Оплатите картой или через СБП — средства сразу появятся на лицевом счёте.
									</div>

									<div class="select-card-feature select-card-feature--success">
										<span class="select-card-feature-icon">✓</span>
										<span>Моментальное зачисление</span>
									</div>
								</div>

								<a
									class="blue-button select-card-action select-card-action--primary"
									href="/zadatNewSchetCard${summa ? "?summa=" + summa : ''}"
									data-payment-type="express"
								>
									<span>Перейти к оплате</span>

									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M5 12H19M19 12L13 6M19 12L13 18"
											stroke="currentColor"
											stroke-width="2"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
									</svg>
								</a>

							</div>


							<!-- Платёж по реквизитам -->
							<div class="select-card-item select-card-item--requisites">

								<div class="select-card-top">
									<div class="sbtn qr"></div>

									<div class="select-card-badge select-card-badge--days">
										ДО 5 РАБ. ДНЕЙ
									</div>
								</div>

								<div class="select-card-content">
									<div class="title">
										Платёж по реквизитам
									</div>

									<div class="description">
										Скачайте реквизиты и выполните обычный банковский перевод.
									</div>

									<div class="select-card-feature select-card-feature--time">
										<span class="select-card-feature-icon">
											◷
										</span>

										<span>Зачисление до 5 рабочих дней</span>
									</div>
								</div>

								<button
									class="blue-button select-card-action select-card-action--secondary"
									data-payment-type="requisites"
								>
									<span>Получить реквизиты</span>

									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M5 12H19M19 12L13 6M19 12L13 18"
											stroke="currentColor"
											stroke-width="2"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
									</svg>
								</button>

							</div>

						</div>

					</div>
				</div>
			`;
                },

                // changeEmail(title = "", inn = "", email = "", new_email = "") {
                //         if (!title || !inn || !email) { return; }
                //         return `
                //         <div class="modal-content-wrapper change-email-modal">
                //         <div class="dialog-title">
                //                 Заявление
                //         </div>
                //         <div class="change-email-modal__description">
                //                 Прошу изменить адрес электронной почты моего личного кабинета на электронной торговой площадке ООО «МЭТС».
                //         </div>
                //         <div class="change-email-modal__params">
                //                 <div class="change-email-modal__row">
                //                         <div class="change-email-modal__label">
                //                                 Заявитель
                //                         </div>
                //                         <div class="change-email-modal__value">
                //                                 ${title}
                //                         </div>
                //                 </div>
                //                 <div class="change-email-modal__row">
                //                         <div class="change-email-modal__label">
                //                                 ИНН
                //                         </div>
                //                         <div class="change-email-modal__value">
                //                                 ${inn}
                //                         </div>
                //                 </div>
                //                 <div class="change-email-modal__row">
                //                         <div class="change-email-modal__label">
                //                                 E-mail
                //                         </div>
                //                         <div class="change-email-modal__value">
                //                                 ${email}
                //                         </div>
                //                 </div>
                //                 <div class="change-email-modal__row">
                //                         <div class="change-email-modal__label">
                //                                 Новый E-mail
                //                         </div>
                //                         <div class="change-email-modal__input-wrapper">
                //                                 <input class="change-email-modal__input" type="email" value="${new_email}" placeholder="Введите новый E-mail">
                //                                 <span class="change-email-modal__clear verifCode__cancel" title="Отменить изменения">&times;</span>
                //                         </div>
                //                 </div>
                //         </div>
                //         <div class="change-email-modal__buttons">
                //                 <button type="button" class="blue-button change-email-modal__btn-confirm">
                //                         Подтвердить
                //                 </button>
                //                 <button type="button" class="blue-button change-email-modal__btn-send">
                //                         Отправить заявление
                //                 </button>
                //         </div>
                // </div>
                // `;
                // },
                /**
                 * Шаблон модального окна для ввода кода подтверждения.
                 *
                 * @param {string} title - Заголовок окна (например, "Подтверждение номера телефона")
                 * @param {string} descriptionText - Текст описания перед замаскированным контактом
                 * @param {string} maskedContact - Уже замаскированное значение (результат работы maskPhone или maskEmail)
                 * @param {number} length - Количество инпутов для ввода кода (по умолчанию 4)
                 * @returns {string} HTML-строка содержимого модалки
                 */
                verifCode(title = "Подтверждение", descriptionText = "", maskedContact = "", length = 4) {
                        // Генерируем нужное количество инпутов для кода
                        let inputsHtml = '';
                        for (let i = 0; i < length; i++) {
                                inputsHtml += `<input class="verif-code__input" type="text" maxlength="1" autocomplete="off" inputmode="numeric" required>`;
                        }

                        return `
                                <div class="modal-pure__infopart" style="overflow: hidden !important;">
                                        <div class="verif-code">
                                        <p class="verif-code__title">${title}</p>
                                        <p class="verif-code__desc">
                                                ${descriptionText} <span style="white-space: nowrap; font-weight: bold;">${maskedContact}</span>
                                        </p>
                                        <div class="verif-code__inputs">
                                                ${inputsHtml}
                                        </div>
                                        <a href="#" class="verif-code__timer">Запросить код ещё раз</a>
                                        </div>
                                </div>
                        `;
                },

        }
        // не модалки но вызываются
        const WindowsKit = {
                catalog(data = []) {
                        const renderItem = (item) => {
                                const hasChildren =
                                        Array.isArray(item.options) &&
                                        item.options.length > 0;

                                if (hasChildren) {
                                        return `
			<div class="catalog-menu__group">
				<a
					href="${item.link ?? '#'}"
					class="catalog-menu__group-title"
				>
					${item.name}
				</a>

				<div class="catalog-menu__group-items">
					${item.options.map(renderItem).join('')}
				</div>
			</div>
		`	;
                                }

                                return `
				<a
					href="${item.link ?? '#'}"
					class="catalog-menu__item"
					data-value="${item.value ?? ''}"
				>
					${item.name}
				</a>
			`;
                        };

                        const renderSection = (section) => {
                                const hasChildren =
                                        Array.isArray(section.options) &&
                                        section.options.length > 0;

                                if (!hasChildren && section.value !== undefined) {
                                        return `
			<a
				href="${section.link ?? '#'}"
				class="catalog-menu__section catalog-menu__section--link"
				data-value="${section.value}"
			>
				<div class="catalog-menu__section-header">
					<div class="catalog-menu__section-icon iicon iicon--${section.icon}"></div>

					<div class="catalog-menu__section-title">
						${section.name}
					</div>
				</div>
			</a>
		`;
                                }

                                return `
		<section class="catalog-menu__section">
			<a
				href="${section.link ?? '#'}"
				class="catalog-menu__section-header catalog-menu__section-header--link"
			>
				<div class="catalog-menu__section-icon iicon iicon--${section.icon}"></div>

				<div class="catalog-menu__section-title">
					${section.name}
				</div>
			</a>

			<div class="catalog-menu__section-content">
				${section.options.map(renderItem).join('')}
			</div>
		</section>
	`;
                        };

                        // Группируем разделы по колонкам
                        const columns = data.reduce((result, section) => {
                                const column = section.column ?? 1;

                                if (!result[column]) {
                                        result[column] = [];
                                }

                                result[column].push(section);

                                return result;
                        }, {});

                        return `
		<div class="catalog-menu">
			<div class="catalog-menu__inner">

				${Object
                                        .keys(columns)
                                        .sort((a, b) => a - b)
                                        .map((column) => `
						<div class="catalog-menu__column">
							${columns[column]
                                                        .map(renderSection)
                                                        .join('')}
						</div>
					`)
                                        .join('')}

			</div>
		</div>
	`;
                },
        };

        const filesForm = {
                /**
                 * Для изображений которые списком загружаем
                 * @returns {String}
                 */
                fileLink() {
                        return `<a target=_blank>
				<div class=rem></div>
				<div class='palka' ondragover='return false;'></div>
				<div class='pic'></div>
				<div class='palka r' ondragover='return false;'></div>
			</a>`;
                },

                imageButtons() {
                        return `<div class='image_buttons'>
					<span class='del' onclick='FK.fileDel(this)'></span>
					<span class='rotate left' onclick="FK.rotateImg(this, 'left')"></span>
					<span class='rotate right' onclick="FK.rotateImg(this, 'right')"></span>
				</div>`;
                },

                // приводим параметры к единому виду (перепроверить)
                _setupOptions(params = {}, form_type = "sign") {
                        // ОБЩИЕ ПАРАМЕТРЫ
                        const options = {
                                useTitle: params.useTitle ?? true,
                                title: params.title ?? 'Файлы',
                                size: parseInt(params.size) || 1,
                                req: params.req || false,

                                is_table: params.is_table ?? false, // tr (для легаси)

                                storeName: params.storeName ?? "",
                                fieldName: params.fieldName || params.listName || "",

                                showLoadBtn: params.showLoadBtn || true,
                        }

                        options.listSizeType = options.size === 1 ? 'single' : 'multi';

                        // ПАРАМЕТРЫ ДЛЯ ФАЙЛОВ КОТОРЫЕ ПОДПИСЫВАЮТСЯ
                        if (form_type === "sign") {
                                options.is_sign_file = true;

                                options.listName = params.listName ?? "";
                                options.accept = params.accept || FK.getAcceptableFileExtension(true, true);
                                options.doSign = params.doSign ?? true;
                                options.btnTitle = params.btnTitle || "Загрузить";

                                options.list_type = options.docType;
                                options.onChangeFileFunc = `fileChange(this, false, ${options.doSign})`;


                        }
                        // ПАРАМЕТРЫ ДЛЯ МЕДИАФАЙЛОВ
                        if (form_type === "media") {
                                options.is_media = true;
                                options.docType = params.docType || 'lotfoto',
                                        options.fileType = params.fileType || "img",
                                        options.requirement = params.requirement || null,
                                        options.isArray = params.isArray || false;
                                options.list_type = options.docType;

                                switch (options.fileType) {
                                        case 'img':
                                                options.accept = 'image/jpeg,.heic';
                                                options.loadTitle = `Не более ${options.size} изображений`;
                                                options.loadText = `Загрузить изображение`;
                                                options.onChangeFileFunc = 'fileChangeQueue(this, true)';
                                                options.dataAttr = 'data-image';
                                                break;
                                        case 'pdf':
                                                options.accept = 'application/pdf';
                                                options.loadTitle = `Не более ${options.size} презентаций`;
                                                options.loadText = `Загрузить презентацию`;
                                                options.onChangeFileFunc = 'fileChangeQueue(this, false, true)';
                                                options.dataAttr = 'data-pdf';
                                                break;
                                }
                                ;


                        }

                        return options;
                },

                _getRootXData(options = {}) {
                        const xData = `{
					getStore() {
						return this;
					},
					${options.docType}: [],
					observer: null,
					timeout: null,

					init() {
						const sync = () => {
							this.${options.docType} = Array.from(this.$el.querySelectorAll(".attfile:not(.removed)"));
						};

						const debouncedSync = () => {
							clearTimeout(this.timeout);
							this.timeout = setTimeout(sync, 100);
						};

						this.observer = new MutationObserver(debouncedSync);
						this.observer.observe(this.$el, {
							childList: true,
							subtree: true
						});

						sync();
					},

					destroy() {
						if (this.observer) {
							this.observer.disconnect();
							this.observer = null;
						}
						if (this.timeout) {
							clearTimeout(this.timeout);
							this.timeout = null;
						}
					}
				}`;
                        return `x-data='${xData}' x-init='init()' @alpine:destroy.window="destroy"`;
                },

                // главный блок
                _getForm(options = {}) {
                        const attributes = [];

                        //			if(options.is_default_xdata) {
                        //				attributes.push(`x-data="{
                        //				getStore() {
                        //					return this;
                        //				},
                        //				${options.fileType}: [],
                        //				}"`);
                        //			}

                        {
                                const cssClasses = ['sf_container', 'form-grid__span-2'];

                                if (options.is_sign_file) {
                                        cssClasses.push(`signfile_${options.listName}`);
                                }

                                if (cssClasses.length > 0) {
                                        attributes.push(`class="${cssClasses.join(" ")}"`);
                                }
                        }

                        if (options.is_default_xdata) {
                                attributes.push(this._getRootXData(options));
                        }

                        if (options.is_sign_file) {
                                return `<div ${attributes.join(" ")}>${this._getFileFormWrapper(options)}</div>`
                        } else if (options.is_media) {
                                // тут дополнительная обертка
                                return `<div ${attributes.join(" ")}>${this._getFormWrapper(options)}</div>`;
                        }
                },

                // доп обертка (для медиа)
                _getFormWrapper(options = {}) {
                        if (!options.is_media) {
                                console.error("Блок только для медиа")
                        }

                        return `<div class="sf-title-container">
				${this._getFileFormTitle(options)}
				${options.req && options.fileType !== 'pdf' ? '<span class="req">*</span>' : ""}
				${options.requirement ? `<span onclick="${options.requirement}" class="img__span">Требования к загружаемым изображениям</span>` : ""}
				${this._getFileFormWrapper(options)}
			</div>`;
                },

                // обертка
                _getFileFormWrapper(options = {}) {
                        const attributes = [];

                        {
                                const cssClasses = ['fileform__wrapper'];

                                if (cssClasses.length > 0) {
                                        attributes.push(`class="${cssClasses.join(" ")}"`);
                                }
                        }

                        // Alpine - связка
                        attributes.push(`data-store='${options.storeName}'`);
                        attributes.push(`data-store-field='${options.fieldName}'`);

                        return `
				<div ${attributes.join(" ")}>
					${this._getFileForm(options)}
				</div>
				`
                },

                // форма
                _getFileForm(options = {}) {
                        const attributes = [];

                        if (options.is_default_xdata) {
                                attributes.push(`x-data="$f('${options.fieldName}')"`);
                        }

                        {
                                const cssClasses = ['fileform', 'fileformNew'];

                                if (options.req) {
                                        cssClasses.push('filereq');
                                }

                                if (options.is_media) {
                                        cssClasses.push('inputform');
                                        cssClasses.push(`${options.fileType}form`);
                                }

                                if (cssClasses.length > 0) {
                                        attributes.push(`class="${cssClasses.join(" ")}"`);
                                }
                        }

                        // у медиа заголовок в обертке выше, и нет listWrapper
                        if (options.is_media) {
                                return `<div ${attributes.join(" ")}>
					${this._getFileListContent(options)}
				</div>`;
                        } else if (options.is_sign_file) {
                                return `<div ${attributes.join(" ")}>
					${this._getFileFormTitle(options)}
					${this._getFileListWrapper(options)}
				</div>`;
                        }

                },

                // заголовок списка
                _getFileFormTitle(options = {}) {
                        if (!options.useTitle) {
                                return '';
                        }

                        const attributes = [];

                        {
                                const cssClasses = [];

                                if (options.is_media === true) {
                                        cssClasses.push("sf-title");
                                }

                                if (options.is_sign_file === true) {
                                        cssClasses.push("filetitle");
                                }

                                if (cssClasses.length > 0) {
                                        attributes.push(`class="${cssClasses.join(" ")}"`);
                                }
                        }

                        return `<div ${attributes.join(" ")}>
					<span>${options.title}</span>
					${this._getTitleTooltip(options)}
				</div>`;
                },

                _getTitleTooltip(options = {}) {
                        if (options.is_media) {
                                if (options.fileType === 'img') {
                                        return `<span class="field-question tooltip" style="cursor:pointer" onclick="MoK.showLotPhotoRequirements()">?</span>`;
                                }

                        }
                        return "";
                },

                // обертка списка
                _getFileListWrapper(options = {}) {
                        const attributes = [`ondragenter="fileDragEnter(this, event)"`, `ondragexit="fileDragExit(this, event)"`, `ondrop="fileDrop(this, event)"`, `ondragover="return false;"`];

                        {
                                const cssClasses = ['filebody', options.listSizeType];

                                if (cssClasses.length > 0) {
                                        attributes.push(`class="${cssClasses.join(" ")}"`);
                                }
                        }

                        return `<div ${attributes.join(" ")} >
					${this._getFileListContent(options)}
				</div>`;
                },

                //  инпут и тело списка
                _getFileListContent(options = {}) {
                        const attributes = [`type="file"`, `accept='${options.accept}'`];

                        if (options.dataAttr) {
                                attributes.push(options.dataAttr);
                        }

                        if (options.onChangeFileFunc) {
                                attributes.push(`onchange="${options.onChangeFileFunc}"`)
                        }


                        if (options.size > 1) {
                                attributes.push('multiple');
                        }

                        let xdata = "";

                        if (options.is_default_xdata) {

                                const initListStr = JSON.stringify(options.init_list);
                                const fileTypeStr = JSON.stringify(options.fileType);
                                xdata = `x-data='dataFileInit(${initListStr}, $el, ${fileTypeStr});'`;
                        }

                        if (options.is_media) {
                                // Большая зона drag-and-drop (показывается только когда файлов нет)
                                const loadBtnBlock = `
					<div class="sf_loadbtn modern-dropzone" onclick="FK.fileOpen(this, event, false)" title="${options.loadTitle}" x-show="value.length === 0">
					    <svg class="dropzone-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
						<path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5" />
					    </svg>
					    <span class="dropzone-title">Перетащите файлы сюда или <span class="dropzone-link">выберите на компьютере</span></span>
					</div>
				    `;

                                // Квадрат добавления (показывается когда есть файлы но не достигнут лимит)
                                const addSquareBlock = `
				<div class="add-file-square"
				     onclick="FK.fileOpen(this, event, false)"
				     x-show="value.length > 0 && value.length < ${options.size}"
				     title="${options.loadTitle}">
				    <svg class="add-square-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
					<path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
				    </svg>
				    <span class="add-square-text">Добавить</span>
				</div>
			    `;

                                const cssClasses = ['filelist', `${options.listSizeType}`, `${options.fileType}list`];


                                return `<input ${attributes.join(" ")} >
					${options.showLoadBtn ? loadBtnBlock : ""}
					<div class="prc" style="display: none;"></div>
					<div class="prg" style="display: none;"></div>

					<div
					class="${cssClasses.join(" ")}"
					data-size='${options.size}'
					data-doc-type="${options.list_type}"
					data-is-array="${options.isArray}"
					${xdata}
					>
						${options.showLoadBtn ? addSquareBlock : ""}

					</div>

					`;
                        } else if (options.is_sign_file) {
                                const loadBtnBlock = `<div class="sf_loadbtn" onclick="FK.fileOpen(this, event, ${options.doSign})">${options.btnTitle}</div>`;

                                const cssClasses = ['filelist', `${options.listSizeType}`];

                                return `<input ${attributes.join(" ")} >
					${options.showLoadBtn ? loadBtnBlock : ""}
					<div class="prc" style="display: none;"></div>
					<div class="prg" style="display: none;"></div>

					<div
					class='${cssClasses.join(" ")}'
					data-size='${options.size}'
					data-doc-type="${options.list_type}">
					${xdata}
					</div>
					`;
                        } else {
                                console.error("Ошибка!")
                        }

                },

                /**
                 * Генерирует html загрузки файлов
                 * Легаси макрос attpdf_blue и attimg_blue
                 * attimg_blue
                 * attpdf_blue
                 * @param {Object} options - Настройки от лота
                 * @returns {Object} Объект для передачи в x-data или шаблон
                 */
                mediaForm(params) {
                        const options = {
                                useTitle: params.useTitle ?? true,
                                title: params.title || 'Файлы',

                                docType: params.docType || 'lotfoto',
                                fileType: params.fileType || "img",
                                size: parseInt(params.size) || 1,
                                req: params.req || false,
                                isArray: params.isArray || false,
                                requirement: params.requirement || null,
                                showLoadBtn: params.showLoadBtn || true,
                                //files: Array.isArray(options.files) ? options.files : []

                                storeName: params.storeName ?? "",
                                fieldName: params.fieldName ?? params.docType ?? "",

                                is_default_xdata: params.is_default_xdata ?? true,
                                init_list: params.init_list ?? [], // если получаем с сервера
                        };

                        switch (options.fileType) {
                                case 'img':
                                        options.accept = 'image/jpeg,.heic';
                                        options.loadTitle = `Не более ${options.size} изображений`;
                                        options.loadText = `Загрузить изображение`;
                                        options.onChangeFileFunc = 'fileChangeQueue(this, true)';
                                        options.dataAttr = 'data-image';
                                        break;
                                case 'pdf':
                                        options.accept = 'application/pdf';
                                        options.loadTitle = `Не более ${options.size} презентаций`;
                                        options.loadText = `Загрузить презентацию`;
                                        options.onChangeFileFunc = 'fileChangeQueue(this, false, true)';
                                        options.dataAttr = 'data-pdf';
                                        break;
                        }
                        ;

                        options.list_type = options.docType;
                        options.is_media = true;
                        options.listSizeType = options.size === 1 ? 'single' : 'multi';

                        return this._getForm(options);
                },

                // заменяет легаси макросы: signfile_blue_body
                signForm(params) {
                        const options = {
                                useTitle: params.useTitle ?? true,
                                title: params.title ?? 'Файлы',
                                listName: params.listName ?? "",
                                fileType: params.fileType ?? "file",

                                size: parseInt(params.size) || 1,
                                req: params.req ?? false,

                                storeName: params.storeName ?? "",
                                fieldName: params.fieldName ?? params.listName ?? "",

                                accept: params.accept || FK.getAcceptableFileExtension(true, true),

                                showLoadBtn: params.showLoadBtn || true,
                                btnTitle: params.btnTitle || "Загрузить",
                                doSign: params.doSign ?? true,

                                is_default_xdata: params.is_default_xdata ?? true,
                                init_list: params.init_list ?? [], // если получаем с сервера
                        };

                        options.list_type = options.listName;
                        options.is_sign_file = true;
                        options.onChangeFileFunc = `fileChange(this, false, ${options.doSign})`;
                        options.listSizeType = options.size === 1 ? 'single' : 'multi';

                        return this._getForm(options);
                }
        };



        const FormGridTemplates = {

                /**
                 * Получаем заголовок поля
                 * @param {type} options
                 * @param {Boolean} [config.span2] - Использовать класс form-grid__span-2 для label
                 * @param {Boolean} [config.use_asterisk] - Использовать x-asterisk - звездочку
                 * @param {Boolean} [config.use_tooltip] - Использовать x-tooltip - подсказка. применяем для заголовка

                 * @returns {String} - html блок с заголовком
                 */
                _getTitleBlock(options = {}) {
                        if (options.hide_title === true) {
                                return "";
                        }

                        const attributes = [];
                        { // стили
                                const cssClasses = [];

                                if (options.is_substep === true) {
                                        cssClasses.push('form-grid__title');
                                }

                                if (options.span2 === true) {
                                        cssClasses.push('form-grid__span-2');
                                }

                                if (cssClasses.length > 0) {
                                        attributes.push(`class='${cssClasses.join(" ")}'`)
                                }
                        }

                        // заголовок
                        function getTitleLabelBlock(options = {}) {
                                const attributes = [`x-html="label"`];

                                // атрибут астериска
                                if (options.use_asterisk === true) {
                                        attributes.push('x-asterisk');
                                }

                                return `<span  ${attributes.join(" ")} ></span>`;
                        }
                        const titleLabelBlock = getTitleLabelBlock(options);

                        // тултипа в виде вопросительного знака
                        function getTitleTooltipBlock(options) {
                                if (options.use_tooltip !== true) {
                                        return "";
                                }

                                const attributes = [`x-tooltip.data.field_question="tooltip"`];

                                return `&nbsp;<span ${attributes.join(" ")}></span>`;
                        }
                        const tooltipBlock = getTitleTooltipBlock(options);

                        return `<span ${attributes.join(" ")}>
					${titleLabelBlock}
					${tooltipBlock}
				</span>`;
                },

                _getDescriptionBlock(options = {}) {
                        if (options.use_description !== true) {
                                return "";
                        }

                        const attributes = [];

                        if (options.use_transition !== false) {
                                attributes.push(`x-transition`);
                        }

                        { // стили
                                const cssClasses = [];

                                if (options.span2 !== false) {
                                        cssClasses.push('form-grid__span-2');
                                }

                                cssClasses.push('form-grid__description');

                                if (options.is_textarea) { // как будто текст заполнен уже
                                        cssClasses.push('textarea--disabled');
                                }

                                if (cssClasses.length > 0) {
                                        attributes.push(`class='${cssClasses.join(" ")}'`)
                                }
                        }



                        if (options.is_radio) {
                                attributes.push(`x-show="option.description && value === option.value"`);
                                attributes.push(`x-html="option.description"`);
                        } else {
                                attributes.push(`x-show="description"`);
                                attributes.push(`x-html="description"`);
                        }

                        return `<div ${attributes.join(" ")} ></div>`;
                },

                /**
                 * Получаем эвенты поля
                 * @param {type} options
                 * @param {Boolean} [config.use_mask] - Использовать x-maska - маску для полей
                 * @param {Boolean} [config.use_xmodel] - Использовать x-model (по умолчанию используем @input, и если есть какое-то событие, требующее контроля событий, hasEvents, то игнорируем x-model и все равно ставим атрибуты событий)
                 * @param {String} [config.on_change] - Использовать @change (передаем выражение)
                 * @param {Boolean} [config.use_count] - Использовать x-count - счетчик символов для поля
                 * @returns {String}  - html атрибуты для поля
                 */
                _getFieldAttributes(options = {}) {
                        const attributes = ['x-field'];

                        if (options.hide_only_field === true) { // прятать только label. по умолчанию все прячем.
                                attributes.push(`x-show.important="visible"`);
                        }

                        { // добавляем классы
                                const cssClasses = [];
                                if (options.span2 === true) {
                                        cssClasses.push(`form-grid__span-2`);
                                }

                                if (options.is_textarea === true && options.is_wide === true) {
                                        cssClasses.push(`textarea--wide`);
                                }

                                if (options.is_short_number === true) {
                                        cssClasses.push('short-number');
                                }

                                if (cssClasses.length > 0) {
                                        attributes.push(`class="${cssClasses.join(" ")}"`);
                                }
                        }

                        { // ==== ДИНАМИЧЕСКИЕ СТИЛИ ====
                                const dynamicCssClasses = [];
                                // По умолчанию включено и показывается если прописан description, отключить при вызове шаблона: use_description: false
                                if (options.is_textarea === true) {
                                        dynamicCssClasses.push("'textarea--readonly': readonly");
                                }

                                if (dynamicCssClasses.length > 0) {
                                        attributes.push(`:class="{${dynamicCssClasses.join(" ")}}"`);
                                }
                        }

                        // атрибут маски
                        if (options.use_mask === true) {
                                attributes.push(`x-maska="mask"`);
                        }

                        // атрибут счетчика
                        if (options.use_count_placeholder === true) { // это случай если нужно выровнять две колонки и одна со счетчиком а другая нет, то мы просто скрытый счетчик делаем
                                attributes.push(`x-count.placeholder`);
                        } else if (options.use_count === true) {
                                attributes.push(`x-count`);
                        }

                        // директива @change
                        if (options.on_change) {
                                attributes.push(`@change="${options.on_change}"`);
                        }

                        // атрибут init
                        if (options.on_init) {
                                attributes.push(`x-init="${options.on_init}"`);
                        }

                        // директива blur
                        if (options.on_blur) {
                                attributes.push(`@blur="${options.on_blur}"`);
                        }

                        //даем атрибут с названием поля чтобы обращаться через jquery (и сразу видеть где используется jquery)
                        if (options.use_jquery === true) {
                                attributes.push(`:jquery="name"`);
                        }

                        // на случай если нужно один атрибут для группы объектов
                        if (typeof options.use_jquery === 'string') {
                                attributes.push(`jquery="${options.use_jquery}"`);
                        }

                        // Добавляем атрибут x-suffix если указан
                        if (options.use_suffix === true) {
                                attributes.push(`x-suffix`);
                        }

                        const hasEvents = options.use_mask || options.on_change || options.use_jquery; // тут все поля

                        // определяем как читаем информацию из поля

                        if (options.use_xmodel === true && !hasEvents) {
                                // простая привязка

                                // x-model лучще использовать для очень простых полей, либо вообще не использовать! случаи когда можно использовать:
                                // 1. Нет formatInput / маски / кастомной логики
                                // 2. Поле просто хранит строку/число без трансформаций
                                // 3. это textarea
                                attributes.push("x-model='value'");
                        } else {
                                // полный контроль
                                attributes.push(":value='value' @input='formatInput($event, name)'");
                        }

                        return ` ${attributes.join(" ")} `;
                },

                /**
                 * Получить список атрибутов для главного контейнера
                 * @param {type} fieldName
                 * @param {type} options
                 * @returns {undefined}
                 */
                _getWrapperAttributes(fieldName, options = {}) {
                        const attributes = [`x-data="$f('${fieldName}')"`];

                        if (options.use_transition !== false) {
                                attributes.push(`x-transition`);
                        }

                        if (options.hide_only_field !== true) { // прятать только основное поле (без description). по умолчанию все прячем.
                                attributes.push(`x-show.important="visible"`);
                        }

                        { // ==== СТАТИЧЕСКИЕ СТИЛИ ====
                                const cssClasses = ['form-grid__block'];

                                if (options.is_substep === true) {
                                        cssClasses.push('wizard__substep');
                                } else if (options.wrapper_span2 === true) {
                                        cssClasses.push('form-grid__span-2');
                                } else if (options.is_2col === true) {
                                        cssClasses.push('form-grid__block--2col');
                                } else if (options.is_2col_mixed === true) {
                                        cssClasses.push('form-grid__block--2col-mixed');
                                } else {
                                        cssClasses.push('form-grid__block--1col');
                                }

                                if (options.is_2col_73 === true) {
                                        cssClasses.push("form-grid__block--2col-7-3");
                                }

                                if (options.nowrap === true) {
                                        cssClasses.push("no-wrap");
                                }
                                if (options.reverse === true) {
                                        cssClasses.push("reverse");
                                }

                                // шаблон с чекбоксом
                                if (options.is_checkbox === true) {
                                        cssClasses.push("form-grid__block--with-checkbox");
                                }

                                if (options.column_auto === true) {
                                        cssClasses.push("grid-column--auto");
                                }

                                if (cssClasses.length > 0) {
                                        attributes.push(`class="${cssClasses.join(" ")}"`);
                                }
                        }

                        { // ==== ДИНАМИЧЕСКИЕ СТИЛИ ====
                                const dynamicCssClasses = [];
                                // По умолчанию включено и показывается если прописан description, отключить при вызове шаблона: use_description: false
                                if (options.use_description === true) {
                                        dynamicCssClasses.push("'form-grid__block--with-description': description");
                                }

                                if (dynamicCssClasses.length > 0) {
                                        attributes.push(`:class="{${dynamicCssClasses.join(" ")}}"`);
                                }
                        }

                        return ` ${attributes.join(" ")} `;
                },

                /**
                 *
                 * @param {type} fieldName
                 * @param {type} options
                 * @param {Boolean} [config.span2] - Использовать класс form-grid__span-2 для label и input

                 * @returns {String}
                 */
                input(fieldName, options = {}) {
                        options.is_input = true; // внутренний параметр

                        // возвращаем поле
                        return `
				<label ${this._getWrapperAttributes(fieldName, options)}>
					${this._getTitleBlock(options)}
					<slot name="before"></slot>
					<div x-grid-cols>
						<slot name="inside_before"></slot>

						<div class="form-grid__block--1col">
							<input ${this._getFieldAttributes(options)}/>
							<slot name="near_input"></slot>
						</div>

						<slot name="default"></slot>
						<slot name="inside_after"></slot>
					</div>
					<slot name="after"></slot>
				</label>
			`;
                },

                textarea(fieldName, options = {}) {
                        options.is_textarea = true; // внутренний параметр
                        options.use_xmodel = true;
                        options.use_count = true; // всегда true
                        options.span2 = true;

                        return `
				<div ${this._getWrapperAttributes(fieldName, options)}>
					<label>
						${this._getTitleBlock(options)}
						<textarea ${this._getFieldAttributes(options)}></textarea>

					</label>
					${this._getDescriptionBlock(options)}
					<slot name="after"></slot>
				<div>
			`;
                },

                date(fieldName, options = {}) {
                        options.is_date = true; // внутренний параметр
                        options.on_init = '$nextTick(() => initCalendar($el))';
                        options.on_blur = `value = FFK.handlers.clearDataOnBlur($event);`;
                        options.is_2col_mixed = true;


                        let additionalDate = '';

                        if (options.use_hours === true) {
                                options.is_2col_mixed = true;
                                options.is_2col_73 = true;

                                const name = `${fieldName}_hh`;

                                additionalDate += `
				<div class="form-grid__block--1col" x-data="$f('${name}')">
					<input
					       x-field
					       :value="value"
					       @input="formatInput($event, name)"
					       />
				</div>
				`
                        }

                        if (options.use_minutes === true) {
                                options.is_2col_mixed = true;
                                options.is_2col_73 = true;

                                const name = `${fieldName}_mm`;

                                additionalDate += `
				<div class="form-grid__block--1col" x-data="$f('${name}')">
					<input
					       x-field
					       :value="value"
					       @input="formatInput($event, name)"
					       />
				</div>
				`
                        }


                        const mainDataBlock = `
			<label ${this._getWrapperAttributes(fieldName, options)}>
				${this._getTitleBlock(options)}
				<slot name="before"></slot>
				<div x-grid-cols>

					<input ${this._getFieldAttributes(options)}>

					${additionalDate}

					<slot name="default"></slot>
					<slot name="inside_after"></slot>
				</div>
				<slot name="after"></slot>
			</label>
			`;


                        return mainDataBlock;
                },

                radio(fieldName, options = {}) {
                        options.is_radio = true; // внутренний параметр
                        options.use_description = true;

                        const titleBlock = `<span class="form-grid__span-2 form-grid__title" x-text="label"></span>`; // тут возможно поменять radio

                        options.wrapper_span2 = true;

                        return `
				<div ${this._getWrapperAttributes(fieldName, options)}>
					${titleBlock}
					<div class='form-grid__span-2 form-radios'>
						<template x-for="(option, index) in options" :key="option.value">
							<div x-show="option.isShow === undefined || (option.isShow === true || (typeof option.isShow === 'function' && option.isShow(store)))">
								<label>
									<input
										type="radio"
										:name='name'
										:value="option.value"
										x-model="value"
										x-field
										>
									<span x-text="typeof option.name === 'function' ? option.name(store) : option.name"></span>
								</label>
								${this._getDescriptionBlock(options)}
							</div>
						</template>
					</div>
				</div>
			`
                },

                select(fieldName, options = {}) {
                        options.is_select = true; // внутренний параметр
                        //options.use_description = true;
                        const noneOptionText = options.noneoption_text ?? ""; // "Не выбран"
                        const nonSelectBlock = options.use_noneoption !== false ? `<option value='-1' :selected="value === '-1'">${noneOptionText}</option>` : "";

                        // атрибуты для обертки
                        const wrapperAttrs = ["class='select-wrapper'"];

                        // Собираем базовые атрибуты для select
                        const selectAttrs = ['x-model="value"', ':name="name"'];
                        const dynamicCssClasses = ["'select--readonly': readonly"];
                        if (dynamicCssClasses.length > 0) {
                                selectAttrs.push(`:class="{${dynamicCssClasses.join(" ")}}"`);
                        }

                        let cols = "";

                        if (options.disable_x_cols === true) {
                                cols = "class='form-grid__block--1col'"; // иначе поля кривые
                        } else if (options.is_2col_73 !== true) { // иначе навешивается form-grid__block--1col и grid span 2 работает и не работает 73
                                cols = "x-grid-cols";
                        }

                        return `
				<div ${this._getWrapperAttributes(fieldName, options)}>
					${this._getTitleBlock(options)}
					<slot name="before"></slot>
					<div ${cols}>
						<slot name="inside_before"></slot>
						<div ${wrapperAttrs.join(" ")}>
							<select ${selectAttrs.join(" ")}>
								${nonSelectBlock}
								<template x-for="(option, index) in options" :key="index">
									<option
										:selected="value === option.value"
										:value="option.value"
										x-text="option.name"
										:class="{'notallowed-option': option.notallowed === true && value !== option.value}"
										></option>
								</template>
							</select>
						</div>
						<slot name="default"></slot>
						<slot name="inside_after"></slot>
					</div>
					${this._getDescriptionBlock(options)}
					<slot name="after"></slot>
				</div>
			`
                },

                signFile(fieldName, options = {}) {
                        options.is_docs = true; // внутренний параметр
                        options.is_substep = true;

                        return `
				<div ${this._getWrapperAttributes(fieldName, options)} x-init="initAlpineFiles(store, name)">
					${this._getTitleBlock(options)}
					<div x-html="util('getTemplate')"></div>
				</div>
			`;
                },

                file(fieldName, options = {}) {
                        options.is_media = true; // внутренний параметр
                        options.is_substep = true;

                        const fileParams = options.file_params ?? {};
                        const fileType = fileParams.type ?? "img";
                        const fileSize = fileParams.size ?? (fileType === "pdf" ? 1 : 30);

                        return `
				<div ${this._getWrapperAttributes(fieldName, options)} x-init="initAlpineFiles(store, name, '${fileType}')">
					${this._getTitleBlock(options)}

					<div x-html="util('getTemplate')"></div>
				</div>
			`;
                },

                checkbox(fieldName, options = {}) {
                        options.is_checkbox = true; // внутренний параметр
                        options.is_2col = true; // стиль
                        let event = ` x-model="value"`;

                        if (options.reverse_value === true) { // случай если у нас выбор галочки означает false
                                event = ` :checked="!value" @change="value = !$event.target.checked" `;
                        }

                        let checkboxBlock = `<input type="checkbox" x-toggle x-field ${event}>`;

                        if (options.use_toggle === false) {
                                const yesLabel = options.yesLabel || 'Да';
                                const noLabel = options.noLabel || 'Нет';

                                if (options.as_select === true) {
                                        checkboxBlock = `
					<div class="select-wrapper">
						<select x-field :name="name"
							:value="value === true || value === 'true'"
							@change="value = $event.target.value === 'true'">
							<option :value="true">${yesLabel}</option>
							<option :value="false">${noLabel}</option>
						</select>
					</div>
					`

                                        const descBlock = this._getDescriptionBlock({ ...options, span2: false, use_description: true });

                                        return `
					<div ${this._getWrapperAttributes(fieldName, options)}>
						<div class="form-grid__title-wrapper">
							${this._getTitleBlock(options)}
						</div>
						<div x-grid-cols.19>
							<div>
								${checkboxBlock}
							</div>
							<div>
								${descBlock}
							</div>
						</div>
					</div>
					`;
                                } else {

                                        checkboxBlock = `
						<label class="form-radio">
						    <input type="radio"
							   :name="name"
							   :checked="value === true || value === 'true'"
							   @click="value = true"
							   x-field>
						    <span>${yesLabel}</span>
						</label>
						<label class="form-radio">
						    <input type="radio"
							   :name="name"
							   :checked="value === false || value === 'false'"
							   @click="value = false"
							   x-field>
						    <span>${noLabel}</span>
						</label>
					    `;
                                }
                        }

                        return `
			<div ${this._getWrapperAttributes(fieldName, options)}>
				<label>
					${this._getTitleBlock(options)}
					<span>
						${checkboxBlock}
					</span>
				</label>
				${this._getDescriptionBlock(options)}
			<div>
			`
                },
        }

        // то, что будет доступно снаружи
        const publicAPI = {
                filesForm: filesForm,
                grid: FormGridTemplates,
                modal: ModalKit,
                ...WindowsKit,
        };

        return publicAPI;
})();
